import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  IBulkPassengerNearBySearchDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { BaseDrawer } from "../drawer";
import { FormDrawer } from "../form-drawer";
import { BulkPassengerNearbySearchForm } from "./bulk-passenger-station-nearby-form";
import { useBulkPassengerNearbySearch } from "./hooks";

export const BulkPassengerNearBySearchDrawer: FC<
  IBulkPassengerNearBySearchDrawerProps & IInjectedDrawerProps
> = ({ drawerNumber, onCloseDrawer }) => {
  const { t } = useTranslation();

  const { methods, handleSearchBulkPassengerNearbyStation } =
    useBulkPassengerNearbySearch();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <FormDrawer
        onCloseDrawer={onCloseDrawer}
        onCancelClick={onCloseDrawer}
        title={t("general.NEARBY_STATION.UPDATE")}
        onSaveClick={handleSearchBulkPassengerNearbyStation}
        footerSaveLabel={t("general.SEARCH")}
        isSaveDisabled={!methods.formState.isValid}
      >
        <FormProvider {...methods}>
          <BulkPassengerNearbySearchForm />
        </FormProvider>
      </FormDrawer>
    </BaseDrawer>
  );
};
